addEventListener('DOMContentLoaded', function() {
	const slidesCount = getMaxSlidesCount();
    var postsSwiper = new Swiper(".posts-swiper", {
      spaceBetween: 20,
      freeMode: false,
      watchSlidesProgress: true,
			loop: true,
			navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
			pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
			autoplay: {
        delay: 2000,
        disableOnInteraction: true,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
        slidesPerView: 1,
        },
        // when window width is >= 480px
        480: {
        slidesPerView: slidesCount > 2 ? 2 : slidesCount,
        },
        // when window width is >= 640px
        640: {
        slidesPerView: slidesCount >= 2 ? 2 : slidesCount,
        },
        // when window width is >= 1200px
        1050: {
        slidesPerView: slidesCount >= 3 ? 3 : slidesCount,
        },
        1200: {
        slidesPerView: slidesCount >= 3 ? 3 : slidesCount,
        },
        1600: {
        slidesPerView: slidesCount >= 4 ? 4 : slidesCount,
        }
    }
    });
		function getMaxSlidesCount () {
			const slidesCount = document.querySelectorAll('.wp-block-dunesblocks-posts-carousel .swiper-slide').length;
			return slidesCount;
		}
});
